<template>
  <Dialog
    :visible="visible"
    @update:visible="$emit('update:visible', $event)"
    :header="loanId ? `История займа №${loanId}` : 'История займа'"
    :modal="true"
    :style="{ width: '900px' }"
    :dismissable-mask="true"
  >
    <div v-if="loading" class="flex justify-content-center p-4">
      <ProgressSpinner></ProgressSpinner>
    </div>
    <DataTable
      v-else
      :value="items"
      :show-gridlines="true"
      responsive-layout="scroll"
      :paginator="items.length > 10"
      :rows="10"
      :rows-per-page-options="[10, 25, 50]"
    >
      <template #empty>
        <div style="text-align: center"><span>Событий по займу нет</span></div>
      </template>
      <Column field="id" header="ID"></Column>
      <Column field="eventType" header="Тип события">
        <template #body="{ data }">
          {{ formatEventType(data) }}
        </template>
      </Column>
      <Column field="cbUuid" header="ЦБ УИД"></Column>
      <Column field="correctionReportId" header="Корректировка">
        <template #body="{ data }">
          <a
            v-if="data.correctionReportId"
            :href="`/functions/resend-loan/${data.correctionReportId}`"
            target="_blank"
          >№{{ data.correctionReportId }}</a>
          <span v-else>—</span>
        </template>
      </Column>
      <Column field="createdAt" header="Создано"></Column>
      <Column field="updatedAt" header="Обновлено"></Column>
    </DataTable>
    <template #footer>
      <Button label="Закрыть" icon="pi pi-times" class="p-button-text" @click="$emit('update:visible', false)" />
    </template>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import LoanHistoryService from "@/service/LoanHistoryService";
import ResponseService from "@/service/ResponseService";

export default {
  name: "LoanHistoryEventsDialog",
  components: { Dialog },
  props: {
    visible: { type: Boolean, default: false },
    loanId: { type: [Number, String], default: null },
  },
  emits: ['update:visible'],
  data() {
    return {
      loading: false,
      items: [],
    }
  },
  watch: {
    visible(val) {
      if (val && this.loanId) {
        this.load();
      }
    },
    loanId(val) {
      if (this.visible && val) {
        this.load();
      }
    }
  },
  methods: {
    formatEventType(data) {
      if (!data) return '';
      const name = this.$filters.translate(this.$store, 'loanHistoryEventType', data.eventType);
      if (data.eventType === 'auto_delete' && data.deleteCode) {
        return `${name} (${data.deleteCode})`;
      }
      return name;
    },
    load() {
      this.loading = true;
      this.items = [];
      LoanHistoryService.list({ loanId: this.loanId }).then((res) => {
        this.items = res.items || [];
      }).catch((err) => {
        ResponseService.handleErrorResponseWithoutForm(err, this.$toast);
      }).finally(() => {
        this.loading = false;
      });
    }
  }
}
</script>
